<template>
    <ProspectSearchLayout :mini="true" :prospectSearch="true" :dataFilter="dataFilter" @get-data="getData"
        @load-data="loadData">
        <div class="prospect_content">
            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                <nav aria-label="breadcrumb" role="navigation" class="m-0">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            Home
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">Prospect</li>
                    </ol>
                </nav>
                <div class="md-toolbar-section-start">
                    <h1 class="section_header p-0">
                    Prospect Search
                    </h1>
                </div>
            </div>
            <md-button class="md-round filterBtn" @click="filter_btn">
                <md-icon>align_horizontal_right</md-icon>Filter
            </md-button>
            <div class="prospect_result" v-if="this.isFilter">
                <md-card>
                    <md-card-header>
                        <md-button class="clear_btn" @click="clearSearch">
                            <md-icon>close</md-icon>Clear Search
                        </md-button>
                        <md-button @click="showSavedList">View Saved Lists</md-button>
                    </md-card-header>
                    <md-card-content>
                      
                        <ul>
                            <li>Total Results</li>
                            <li>
                                <h2>{{ this.totalResultsCount }}</h2>
                            </li>
                        </ul>
                        <div v-if="!this.isBigger" class="action_wpr">
                            <router-link v-bind:to="getUrl()">
                                <md-button :disabled="!industry">
                                    <div class="dark-blue-color">
                                        Access List
                                        <md-icon>keyboard_double_arrow_right</md-icon>
                                    </div>
                                </md-button>
                            </router-link>
                        </div>
                    </md-card-content>
                </md-card>                 
                 <PulseLoader :loading="loaded" :class="{ hide: !loaded }"
                            quote="Action is the foundational key to all success" author="Pablo Picasso"
                            profession="Spanish Painter" img="picasso.jpg">
                  </PulseLoader>
            </div>
            
            <md-card class="initial_area" v-else>
                <md-card-header>
                    Begin you prospecting by selecting an Industry
                    <md-icon>keyboard_backspace</md-icon>
                    <md-button class="md_button_view_saved_list" @click="showSavedList">View Saved Lists</md-button>
                </md-card-header>
                <md-card-content></md-card-content>
            </md-card>
            <modal v-if="savedList" @close="closeReset()" class="saved_list_modal">
                <template slot="header">
                    <h3 class="modal-title">Saved Lists</h3>
                    <button type="button" class="close_btn" @click="savedList = false">
                        <md-icon>clear</md-icon>
                    </button>
                </template>
                <template slot="body">
                    <div class="container">
                        <md-field>
                            <md-input type="text" v-model="search" aria-label="search" placeholder="Search..." @input="filterArray"
                                class="input-custom" />
                            <md-icon>search</md-icon>
                        </md-field>
                    </div>

                    <div v-if="loadedViewSavedList" class="div-pulse-loaded">
                        <PulseLoader :loading="loadedViewSavedList" class="pulse-loaded"></PulseLoader>
                    </div>
                    <ul v-else class="saved_list scroll-list">
                        <li v-bind:key="key" v-for="(item, key) in this.savedListsReceived">
                            <div class="list_title">
                                <h5>{{ item.name }}</h5>
                                <p>{{ formatDate(item.date) }}</p>
                            </div>
                            <md-button @click="checkPurchased(item, key)">Open List</md-button>
                        </li>
                    </ul>
                </template>
            </modal>
            <modal v-if="partialList" @close="partialList = false">
                <template slot="header">
                    <h3 class="modal-title">Enter the number you want to prospect a list</h3>
                    <button type="button" class="close_btn" @click="partialList = false">
                        <md-icon>clear</md-icon>
                    </button>
                </template>
                <template slot="body">
                    <div class="field_wpr">
                        <div class="input_wpr">
                            <input aria-label="data" type="number" placeholder="Enter the number of data" v-model="countUserType" />
                        </div>
                        <md-button @click="access(listDataModel)">Show Me</md-button>
                    </div>
                </template>
            </modal>
        </div>
    </ProspectSearchLayout>
</template>
<script>
import ProspectSearchLayout from '@/pages/Layout/ProspectSearchLayout'
import { Modal, Pagination } from '@/components'
import { PulseLoader } from '@/components';
import Vuex, { mapActions } from 'vuex';
import axios from 'axios';
export default {
    name: 'ProspectSearch',
    components: {
        ProspectSearchLayout,
        Modal,
        PulseLoader,
    },
    data() {
        return {
            listDataModel: null,
            partialList: false,
            countUserType: null,
            checked: [],
            savedList: false,
            totalResultsCount: 0,
            id: null,
            price: null,
            isFilter: false,
            loaded: false,
            loadedViewSavedList: false,
            savedListsReceived: null,
            savedListsReceivedMemory: null,
            search: null,
            industry: 0,
            limit: 500000,
            isBigger: false,
            dataFilter: null,
        }
    },
    computed: {
        profileId() {
            return this.$store.getters.ProfileId;
        },
        psTotal() {
            return this.$store.getters.psTotal ? this.$store.getters.psTotal.replace(/[^a-z0-9]/gi, '') : null;
        },
        psId() {
            return this.$store.getters.psId ?? null;
        }
    },
    methods: {
        showSavedList: function () {
            this.getSavedLists();
            this.savedList = true;
        },
        getData: function (e) {
            this.isBigger = this.limit <= e.total
                ? true
                : false;

            this.isFilter = true;
            this.totalResultsCount = this.numberWithCommas(e.total);
            this.id = e.id;
            this.price = e.price;
            this.industry = e.industry;

            if (this.price)
                this.$store.commit('PS_SET_PRICE', this.price);

            this.$store.commit('PS_SET_ID', this.id);
            this.$store.commit('PS_SET_TOTAL', this.totalResultsCount);
            this.$store.commit('PS_SET_NAME', null);
            this.$store.commit('PS_SET_IS_SAVED', false);

        },
        loadData: function (e) {
            this.isFilter = e.isFilter;
            this.loaded = e.isLoading;
            this.industry = e.industry;
        },
        filter_btn: function () {
            document.querySelector('.main-navbar .md-toolbar-toggle').click();
        },
        clearSearch: function () {
            document.querySelector('#clear-search-prospect').click();
        },
        getUrl: function () {
            return `/search-list/${this.psId}/${this.psTotal}`;
        },
        numberWithCommas: function (number) {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        filter: async function (listData) {
            let currentSession = localStorage.getItem(
                'vue-authenticate.vueauth_access_token'
            );

            await axios
                .post(
                    process.env.VUE_APP_API_BASE_URL + '/user/search_lists/company',
                    {},
                    {
                        params: {
                            /**
                             * Required parameters:
                             */
                            type: 'company',
                            session_id: currentSession,
                            profile_id: listData.list_id,
                            viewSelectionOnly: true,
                        },
                    }
                )
                .then((res) => {
                    if (res.hasOwnProperty('data') && res.data.error) {
                        this.$store.commit('SET_ERROR_BIT', true);
                        this.$store.commit(
                            'SET_ERROR_INFO',
                            '<br>' +
                            'Server responded with error = True <br> errorCode: ' +
                            res.data.errorCode +
                            `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/industries" <br>`
                        );

                        throw new Error(
                            '<br>' +
                            'Server responded with error = True <br> errorCode: ' +
                            res.data.errorCode
                        );
                    }
                    else {
                        this.$store.commit('PS_SET_ID', res.data.id);
                        this.dataFilter = res.data;
                        this.$store.commit('SET_INDUSTRY', `${this.dataFilter.industry_text} [${this.dataFilter.industry}]`);
                        this.$store.commit('SET_MARKET_AREA', `${this.dataFilter.area_text} [${this.dataFilter.area}]`);
                        this.loaded = false;
                    }
                });
        },
        getSavedLists: function () {
            let currentSession = localStorage.getItem(
                'vue-authenticate.vueauth_access_token'
            );
            if (!this.savedListsReceived)
                this.loadedViewSavedList = true;
            axios
                .post(
                    process.env.VUE_APP_API_BASE_URL + '/user/search_lists/companySavedLists',
                    {},
                    {
                        params: {
                            session_id: currentSession,
                        },
                    }
                )
                .then((res) => {
                    if (res.hasOwnProperty('data') && res.data.error) {
                        this.$store.commit('SET_ERROR_BIT', true);
                        this.$store.commit(
                            'SET_ERROR_INFO',
                            '<br>' +
                            'Server responded with error = True <br> errorCode: ' +
                            res.data.errorCode +
                            `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/industries" <br>`
                        );

                        throw new Error(
                            '<br>' +
                            'Server responded with error = True <br> errorCode: ' +
                            res.data.errorCode
                        );
                        this.loadedViewSavedList = false;
                    }
                    else {
                        const { id } = res.data.data;
                        this.$store.commit('SET_PROFILE_ID', id);
                        this.savedListsReceived = res.data.data.sort(function (a, b) {
                            return new Date(b.date) - new Date(a.date);
                        });
                        this.savedListsReceived = this.savedListsReceived.filter((item) => {
                            if (item.purchased_records < item.total_records)
                                return item;
                        });
                        this.loadedViewSavedList = false;
                    }
                });
        },
        formatDate: function (dateString) {
            let date = new Date(dateString);
            return ((date.getMonth() > 8) ?
                (date.getMonth() + 1)
                : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9)
                    ? date.getDate()
                    : ('0' + date.getDate())) + '/' + date.getFullYear();
        },
        openList: async function (itemList) {

            let currentSession = localStorage.getItem(
                'vue-authenticate.vueauth_access_token'
            );
            await axios
                .post(
                    process.env.VUE_APP_API_BASE_URL + '/user/search_lists/companyFromExisting',
                    {},
                    {
                        params: {
                            session_id: currentSession,
                            list_id: itemList.list_id,
                            count: itemList.total_records,
                        },
                    }
                )
                .then((res) => {
                    if (res.hasOwnProperty('data') && res.data.error) {
                        this.$store.commit('SET_ERROR_BIT', true);
                        this.$store.commit(
                            'SET_ERROR_INFO',
                            '<br>' +
                            'Server responded with error = True <br> errorCode: ' +
                            res.data.errorCode +
                            `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/industries" <br>`
                        );

                        throw new Error(
                            '<br>' +
                            'Server responded with error = True <br> errorCode: ' +
                            res.data.errorCode
                        );

                    }
                    else {
                        this.isFilter = true;

                        this.totalResultsCount = this.separator(res.data.count);
                        this.price = res.data.price;
                        this.savedList = false;
                        this.search = null;
                        if (this.price)
                            this.$store.commit('PS_SET_PRICE', this.price);
                        // this.$store.commit('PS_SET_ID', this.id);
                        this.$store.commit('PS_SET_TOTAL', this.totalResultsCount);
                        this.$store.commit('PS_SET_NAME', itemList.name);
                        this.$store.commit('PS_SET_IS_SAVED', true);

                        let params = {
                            product_id: res.data.product_id
                        };

                        this.$store.dispatch('cart/accessProduct', params).then((res) => {

                            if (res.cart) {
                                this.$router.push({
                                    name: 'Cart',
                                    params: { listId: params.product_id },
                                });
                            }

                            if (res.access || (res.error && res.errorCode === 'product_already_accessed')) {
                                this.$router.push({
                                    name: 'CompaniesList',
                                    params: { id: params.product_id },
                                });
                            }
                        });
                    }
                });
        },
        filterArray: function () {
            if (this.search) {
                if (!this.savedListsReceivedMemory)
                    this.savedListsReceivedMemory = [].concat(this.savedListsReceived);

                let salvedListFiltered = this.savedListsReceived.filter(item => item.name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0);
                this.savedListsReceived = salvedListFiltered;
            }
            else {
                this.savedListsReceived = this.savedListsReceivedMemory
                this.savedListsReceivedMemory = null;
            }
        },
        closeReset: function () {
            this.savedList = false;
            this.search = null
        },
        separator: function (numb) {
            var str = numb.toString().split(".");
            str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return str.join(".");
        },
        checkPurchased(listData) {

            if (listData.purchased && listData.purchased_records !== listData.total_records) {
                this.partialList = true;
                this.listDataModel = listData;
            }
            else {
                this.loaded = true;
                this.filter(listData);
                this.savedList = false;
            }

        },
        async access(listData) {
            if (this.countUserType) {
                listData.total_records = this.countUserType;
                this.openList(listData);
            }
        }
    },
}
</script>
<style lang="scss">
.scroll-list {
    overflow-y: scroll;
    max-height: 300px;

    &::-webkit-scrollbar {
        width: 6px;
        background: #e5e5e5;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #aaa;
        border-radius: 3px;
    }
}

.prospect_content .prospect_result .md-card .md-card-header .md-button,
.search_panel .filter_list li .dropdown_area .md-button,
.prospect_content .prospect_result .md-card .md-card-content ul li h2,
.prospect_content .prospect_result .md-card .md-card-content .action_wpr .md-button .md-icon,
.search_panel .filter_list li .md-icon,
#industryDiv > div.step-progress__step-sub-label > div > div.favourite > i {
    color: #002277 !important;
}

.prospect_content .prospect_result .md-card .md-card-header .md-button.clear_btn,
.prospect_content .prospect_result .md-card .md-card-header .md-button.clear_btn .md-icon,
.search_panel .md-button.clear_btn,
.search_panel .md-button.clear_btn .md-icon {
    color: #A51309 !important;
}

.search_panel .filter_list li .dropdown_area .new-profile .step-progress__wrapper .step-progress__bar .custom-step-pro .favourite_list,
.step-progress__step-sub-label {
    color: #000000 !important
}

.search_panel .filter_list li .dropdown_area .new-profile .step-progress__wrapper .step-progress__bar .custom-step-pro .step-progress__step .step-progress__step-sub-label .progress-step-actions .action-text{
    color: #ffffff;
    background-color: #7041e5
}

.new-profile .step-progress__wrapper .step-progress__bar .favourite_list .notify {
    background-color: #2E612E !important;
}

.dropdown_area>.header{
    background-color: #002277 !important;
}

.sidebar.collapsed.mini li i,
.sidebar:after{
    color: #ffffff !important;
    background-color: #003461 !important;
}
</style>